// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"860da19f","344":"9687e32f","703":"bd526253","723":"9fb2b4f5","843":"78b50244","890":"ad8660c6","954":"b613f219"}[chunkId] + ".chunk.js";
};